import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import * as typeformEmbed from '@typeform/embed';

declare var $: any;

@Injectable({
  providedIn: 'root'
})

export class SurveyService extends BaseService {

  getSurvey(onSuccess: (data: any) => void, onError: (data: any) => void = null): any {
    this.get(`/survey`)
      .subscribe(
        resp => {
          onSuccess(resp.data);
        },
        err => {
          onError(err);
        });
  }

  dismissSurvey(id: string, onSuccess: (data) => void, onError: (data) => void = null): any {
    this.put(`/survey?Id=${id}`)
      .subscribe(
        resp => {
          onSuccess(resp);
        },
        err => {
          onError(err);
        });
  }

  public showSurvey(link: string): void {
    const utc = this.getUtc();
    const linkSurvey = link + utc;

    const reference = typeformEmbed.makePopup(
      linkSurvey,
      {
        mode: 'popup'
        // onSubmit() {
        //   reference.close();
        // }
      }
    );

    reference.open();
  }

  public getUtc: Function = () => {
    const timeZoneOffset = new Date().getTimezoneOffset();
    if (timeZoneOffset < 0) {
      return `${timeZoneOffset / -60}`;
    } else {
      return  `${timeZoneOffset / 60}`;
    }
  }
}
